module.exports = __webpack_public_path__ + "img/1543989730.90b07d5a.jpg";